import "../stylesheets/day.scss";
import { FormEvent, useEffect, useState } from "react";
import { DayType, editSchedule, getSchedule } from "../services/api";
import EditButton from "./EditButton";
import { isEditor } from "../services/utils";
import { useNotification } from "../contexts/NotificationContext";

type DayProps = {
	name: string;
};

function Day({ name }: DayProps) {
	const { notify } = useNotification();

	const [open, setOpen] = useState<string>("--");
	const [close, setClose] = useState<string>("--");
	const [isEditing, setEditing] = useState<boolean>(false);
	const [draftOpen, setDraftOpen] = useState<string>("");
	const [draftClose, setDraftClose] = useState<string>("");

	const formId = `day-form-${name}`;

	useEffect(() => {
		const fetchSchedule = async () => {
			try {
				const response = await getSchedule(name);
				if (response != null) {
					setOpen(response.open);
					setClose(response.close);
				}
			} catch (e) {
				// rien
			}
		};
		fetchSchedule();
	}, [name]);

	const handleEditToggle = () => {
		if (!isEditing) {
			setDraftOpen(open);
			setDraftClose(close);
		}
		setEditing(!isEditing);
	};

	const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const editedDay: DayType = { name, open: draftOpen, close: draftClose };
		const response = await editSchedule(editedDay);
		if (response) {
			setOpen(draftOpen);
			setClose(draftClose);
			notify({ type: "validation", title: "Horaires mis à jour !" });
			setEditing(false);
		} else {
			notify({ type: "error", title: "Impossible de modifier..." });
		}
	};

	return (
		<div className={`day primary-text${isEditing ? " editing" : ""}`}>
			<div className="edit-buttons">
				{isEditing && (
					<EditButton
						variant="send"
						type="submit"
						form={formId}
						showText={false}
					/>
				)}
				{isEditor() && (
					<EditButton
						variant="edit"
						type="button"
						showText={false}
						onClick={handleEditToggle}
					/>
				)}
			</div>

			<span>{isEditing ? name : name.substring(0, 3) + "."}</span>

			<form id={formId} onSubmit={handleSubmit}>
				<div className="hours">
					{isEditing ? (
						<>
							<input
								type="text"
								name="open"
								placeholder="18:00"
								value={draftOpen}
								onChange={(e) => setDraftOpen(e.target.value)}
							/>
							<span className="separator">-</span>
							<input
								type="text"
								name="close"
								placeholder="00:00"
								value={draftClose}
								onChange={(e) => setDraftClose(e.target.value)}
							/>
						</>
					) : (
						<>
							<span>{open}</span>
							<span className="separator">-</span>
							<span>{close}</span>
						</>
					)}
				</div>
			</form>
		</div>
	);
}

export default Day;
